import queryString from 'query-string'
import {deburr, toLower} from 'lodash'

export function isRunningInDevelopmentMode() {
  /* eslint-disable no-undef */
  if (process.env.NODE_ENV && process.env.NODE_ENV === 'development' && typeof SERVED_BY_SERVER === 'undefined') {
  /* eslint-enable no-undef */
    return true
  }
  return false
}

export function d(debugId = '', obj) {
  console.log(debugId, JSON.stringify(obj))
}

export function getReturnTo() {
  const parsed = queryString.parse(window.location.search)
  return parsed['return-to'] || '/'
}

export function getParamFromQueryString(queryStringInput, paramName) {
  if (!queryStringInput) return undefined
  const parsed = queryString.parse(queryStringInput)
  return parsed[paramName]
}

export function startsWithVowel(string) {
  const sanitized = toLower(deburr(string))
  return /^[aiueo]/.test(sanitized)
}

export function getArticle(string) {
  return startsWithVowel(string) ? 'az' : 'a'
}



// WEBPACK FOOTER //
// ./src/utils.js